import { IconWrapper } from '../runtime';
export default IconWrapper('form_format_s', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2Z",
      "fill": "#009BBA"
    }
  }), h("path", {
    "attrs": {
      "d": "M2 16C0.895431 16 0 15.1046 0 14L16 14C16 15.1046 15.1046 16 14 16L2 16Z",
      "fill": "#0086A0"
    }
  }), h("path", {
    "attrs": {
      "d": "M8 16L8 14L16 14C16 15.1046 15.1046 16 14 16L8 16Z",
      "fill": "#09B2D4"
    }
  }), h("path", {
    "attrs": {
      "d": "M12 3H8.75L7.25 5.5H3.99507V7H8L9.5 4.5H10.5V9.5H5.49219V8H3.99219V11H12V3Z",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "d": "M4 4.5V4.4865L5 3H7.5L6.48987 4.5H4Z",
      "fill": "white"
    }
  })]);
});